import { Form, message, Modal } from "antd";
import useMutation from "hooks/useMutation";
import { showErrorModal } from "utils";
import Formulario from "./Formulario";
import { updateLinea } from "./api";

const Editar = ({ onClose, selectedLinea }) => {
  const [form] = Form.useForm()

  const update = useMutation({
    mutationFn: updateLinea,
    onSuccess: (res) => {
      message.success(res.message);
      onClose();
    },
    onError: err => showErrorModal({ err }),
  });

  const onFinish = (values) => {
    const payload = {
      ...values,
      id: selectedLinea?.id,
    };

    update.mutate(payload);
  };

  return (
    <Modal
      title={`Editar línea ${selectedLinea?.linea}`}
      open={true}
      okText="Guardar"
      width={600}
      onCancel={() => onClose()}
      onOk={() => form.submit()}
      confirmLoading={update.loading}
      cancelButtonProps={{ disabled: update.loading }}
      style={{ top: '5%' }}
      keyboard={false}
    >
      <Formulario
        form={form}
        onFinish={onFinish}
        selectedLineaId={selectedLinea?.id}
      />
    </Modal>
  )
};

export default Editar;